export default "__VITE_ASSET__BmUxhUBK__"